var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{ref:"alert",staticClass:"background",style:({ opacity: _vm.opacity })},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }